import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-1 text-center" }
const _hoisted_2 = { class: "text-3xl font-gotham-bold text-brand-secondary" }
const _hoisted_3 = { class: "mt-0 lg:mt-4" }
const _hoisted_4 = { class: "flex justify-center text-center items-center text-gray-700" }
const _hoisted_5 = { class: "leading-7" }
const _hoisted_6 = {
  key: 0,
  class: "mb-1 tracking-tight font-extrabold text-4xl"
}
const _hoisted_7 = {
  key: 0,
  class: "my-1 lg:my-1 text-gray-700 font-gotham-bold"
}
const _hoisted_8 = { class: "font-gotham-bold text-gray-700" }
const _hoisted_9 = {
  role: "list",
  class: "mt-2 mb-2 space-y-2 hidden lg:block font-gotham-medium"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "ml-3 pt-1 text-gray-700 text-left" }
const _hoisted_12 = { class: "ml-3 pt-1 text-gray-700" }
const _hoisted_13 = { class: "ml-3 pt-1 text-gray-700" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "bg-brand-button font-gotham-bold text-brand-button-text px-8 py-2 rounded-full mx-6 lg:mx-10 mt-3",
  onclick: "javascript:document.getElementById('primary-address-search').focus()"
}

import { CheckIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import { BrandServiceInterface, PlanSelectorProductInformation } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number,
  discountedPrice?: number,
  discounted?: boolean,
  displayDiscount?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HispPlanSelectorProduct',
  props: {
    canSelectProduct: { type: Boolean },
    isSelectedProduct: { type: Boolean },
    product: {},
    planSelectorProductInformation: {}
  },
  emits: ["onPlanSelected"],
  setup(__props: any, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

const emit = __emit;

const mostPopular = computed(() => {
  return props.product.download === 250
    ? 'text-gray-800 hover:bg-brand-primary font-gotham-bold'
    : 'text-gray-800 hover:bg-brand-primary font-gotham-bold';
});

const standardFeatures = ref(props.planSelectorProductInformation.standardFeatures).value;
const standardLinks = ref(props.planSelectorProductInformation.standardLinks).value;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPlanSelected', _ctx.product.id))),
    class: _normalizeClass(["my-2 lg:my-0 transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col lg:w-1/4 border-solid", { 'border-black border': _ctx.isSelectedProduct, 'border border-gray-200': !_ctx.isSelectedProduct, 'cursor-pointer': _ctx.canSelectProduct }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(['tracking-tight font-gotham-bold', _ctx.product.displayDiscount ? 'text-2xl text-gray-700 text-decoration-line: line-through' : 'text-5xl font-extrabold'])
            }, "$" + _toDisplayString(_ctx.product.price), 3),
            (_ctx.product.displayDiscount)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "$" + _toDisplayString(_ctx.product.discountedPrice), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-1 text-xl font-gotham-bold" }, "/Month", -1))
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "inline-flex items-center my-2 px-2.5 py-0.5 rounded-full text-md font-gotham-medium bg-brand-secondary text-white" }, "Unlimited Data!")
      ], -1)),
      (_ctx.product.typicalEveningSpeed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.product.typicalEveningSpeed) + " Mbps", 1),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _cache[4] || (_cache[4] = _createTextVNode("typical evening speed"))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_9, [
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_unref(CheckIcon), {
            class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.product.description), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardFeatures), (standardFeature) => {
          return (_openBlock(), _createElementBlock("li", {
            key: standardFeature,
            class: "flex"
          }, [
            _createVNode(_unref(CheckIcon), {
              class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_12, _toDisplayString(standardFeature), 1)
          ]))
        }), 128)),
        (_openBlock(), _createElementBlock("li", {
          key: _ctx.product.name,
          class: "flex text-left"
        }, [
          _createVNode(_unref(CheckIcon), {
            class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.product.download) + " / " + _toDisplayString(_ctx.product.upload) + " (Mbps download/upload) ", 1)
        ]))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardLinks), (standardLink) => {
        return (_openBlock(), _createElementBlock("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href font-gotham-bold text-brand-primary hover:text-blue-800 hover:underline underline transition duration-250 my-1"
        }, _toDisplayString(standardLink.name), 9, _hoisted_14))
      }), 128))
    ]),
    (_ctx.canSelectProduct)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["transition duration-250 text-gray-800", [mostPopular.value, 'mt-0 lg:mt-8 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium text-gray-800', _ctx.isSelectedProduct ? 'bg-brand-primary text-gray-800' : 'bg-brand-primary-light']])
        }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Plan'), 3))
      : (_openBlock(), _createElementBlock("button", _hoisted_15, "Check Address"))
  ], 2))
}
}

})